import { AppService } from './AppService';

export class SouscriptionService{
    appService = new AppService();
    //API_URL = 'http://localhost/sfrwebapp/api/'
    constructor(){
        //this.appService = 
        //const API_URL = 'http://localhost/sfrwebapp/api/'
    }

    getAllPendingByCodevendeur(codeVendeur) {
        const url = this.appService.getApiUrl()+'souscription/souscription.php';
        const params = {
            codeVendeur: codeVendeur,
            action: 'getAllPendingByCodevendeur'
        };
        return this.appService.get(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }




    cancelSouscription(idSouscription) {
        const url = this.appService.getApiUrl()+'souscription/souscription.php';
        //const url = "http://localhost/sfrwebapp/api/"+'user/user.php';
        const params = {
            idSouscription:idSouscription,
            action: 'cancelSouscription'
        };
        return this.appService.get(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    sendAriadNextLinkBySmsAndEmail(linkType,link,contactEmail,contactNumMobile) {
        const url = this.appService.getApiUrl()+'souscription/souscription.php';
        const params = {
            linkType: linkType,
            link: link,
            contactEmail: contactEmail,
            contactNumMobile: contactNumMobile,
            action: 'sendAriadNextLinkBySmsAndEmail'
        };
        return this.appService.get(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    sendGeolocBySmsAndEmail(codeVendeur,contactEmail,contactNumMobile) {
        const url = this.appService.getApiUrl()+'souscription/souscription.php';
        const params = {
            codeVendeur: codeVendeur,
            contactEmail: contactEmail,
            contactNumMobile: contactNumMobile,
            action: 'sendGeolocBySmsAndEmail'
        };
        return this.appService.get(url,{params})
            .then(function (response) {
                
                return response.data
    
            })
            .catch(function (error) {
                
                throw new Error(error);
                
            });
    }

    



}